import React from 'react';

export const ProfileCirclePrimaryIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="20" cy="20" r="20" fill="#774EFF" />
      <mask
        id="mask0_2304_820"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="11"
        y="11"
        width="18"
        height="19"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.4167 15.9173C15.4167 13.3507 17.4333 11.334 20 11.334C22.5667 11.334 24.5833 13.3507 24.5833 15.9173C24.5833 18.484 22.5667 20.5007 20 20.5007C17.4333 20.5007 15.4167 18.484 15.4167 15.9173ZM28.25 26.9173V28.7507C28.25 29.3007 27.8833 29.6673 27.3333 29.6673C26.7833 29.6673 26.4167 29.3007 26.4167 28.7507V26.9173C26.4167 25.359 25.225 24.1673 23.6667 24.1673H16.3333C14.775 24.1673 13.5833 25.359 13.5833 26.9173V28.7507C13.5833 29.3007 13.2167 29.6673 12.6667 29.6673C12.1167 29.6673 11.75 29.3007 11.75 28.7507V26.9173C11.75 24.3507 13.7667 22.334 16.3333 22.334H23.6667C26.2333 22.334 28.25 24.3507 28.25 26.9173ZM20 18.6673C18.4417 18.6673 17.25 17.4757 17.25 15.9173C17.25 14.359 18.4417 13.1673 20 13.1673C21.5583 13.1673 22.75 14.359 22.75 15.9173C22.75 17.4757 21.5583 18.6673 20 18.6673Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2304_820)">
        <rect x="9" y="9.50061" width="22" height="22" fill="white" />
      </g>
    </svg>
  );
};
